(() => {
const $96b1a9f85714ffa1$var$buttons = document.querySelectorAll(".fcb-store-list-item__launcher");
$96b1a9f85714ffa1$var$buttons.forEach((button)=>{
    button.addEventListener("click", ()=>{
        document.querySelectorAll(".fcb-store-list-item.active, .fcb-store.active").forEach((el)=>{
            el.classList.remove("active");
        });
        const parent = button.parentElement;
        parent.classList.add("active");
        const storeInfo = document.querySelector(".fcb-store-info");
        storeInfo.classList.add("open");
        const storeId = button.dataset.storeId;
        const store = document.querySelector(`.fcb-store[data-store-id="${storeId}"]`);
        store.classList.add("active");
    });
});

})();
//# sourceMappingURL=store-finder.js.map
